"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultModifiers = exports.showOn = exports.orientation = void 0;
exports.orientation = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    'top-start': 'top-start',
    'top-end': 'top-end',
    'bottom-start': 'bottom-start',
    'bottom-end': 'bottom-end',
    'left-start': 'left-start',
    'left-end': 'left-end',
    'right-start': 'right-start',
    'right-end': 'right-end',
};
exports.showOn = {
    hover: 'hover',
    click: 'click',
};
exports.defaultModifiers = {
    offset: {
        offset: '0, 7',
    },
};
